/**
 * Log level enumeration
 * Defines the severity levels for logging
 */
export enum ELogLevel {
	DEBUG = 0,
	INFO = 1,
	WARN = 2,
	ERROR = 3,
}

export const DEFAULT_NAMESPACE = 'default';
